// extracted by mini-css-extract-plugin
module.exports = {"customCheckbox":"Checkbox_customCheckbox__1eY6b","customIcon":"Checkbox_customIcon__1EMd9","input":"Checkbox_input__1gE3o"};